export const cleanJobTitle = (job_title) => {
    return job_title.replaceAll(/[^(\x20-\x7F)\x0A\x0D]*/ig, '');
    
}

export const buildJobURL = (job_category, job_city, job_state, job_zip, job_id) => {
    job_category = job_category ?? ""
    job_city = job_city ?? ""
    job_state = job_state ?? ""
    job_zip = job_zip ?? 0


    job_category = job_category.toLowerCase().replaceAll(/[^a-z0-9_\s-]/ig, ''); //Make alphanumeric (removes all other characters)
    job_city = job_city.toLowerCase().replaceAll(/[^a-z0-9_\s-]/ig, ''); //Make alphanumeric (removes all other characters)
    job_state = job_state.toLowerCase().replaceAll(/[^a-z0-9_\s-]/ig, ''); //Make alphanumeric (removes all other characters)
    
    job_category = job_category.replaceAll(/[\s-]+/ig, " ").trim(); //Clean up multiple dashes or whitespaces
    job_category = job_category.replaceAll(/[\s_]/ig, "-"); //Convert whitespaces and underscore to dash

    job_city = job_city.replaceAll(/[\s-]+/ig, " ").trim(); //Clean up multiple dashes or whitespaces
    job_city = job_city.replaceAll(/[\s_]/ig, "-"); //Convert whitespaces and underscore to dash

    job_state = job_state.replaceAll(/[\s-]+/ig, " ").trim(); //Clean up multiple dashes or whitespaces
    job_state = job_state.replaceAll(/[\s_]/ig, "-"); //Convert whitespaces and underscore to dash

    job_zip = job_zip.trim()

    return `/jobs/${job_category}-${job_city}-${job_state}/hc/${job_id}-${job_zip}/j/`     
}

export const cleanJobDescHTML = (job_desc) => {
    let job_desc_cleaned = job_desc.replaceAll(/\<[\/]?(table|tbody|tr|td)([^\>]*)\>/ig, '');	//remove table code.
    job_desc_cleaned = job_desc_cleaned.replaceAll(/<([b-z][a-z0-9]*)[^>]*?(\/?)>/sig,'<$1$2>'); //remove any html attributes - needed for json LD (anchors excluded)
    job_desc_cleaned = job_desc_cleaned.replaceAll(/href=\"([a-z0-9_\.-]+)@([a-z0-9_\.-]+)\"/sig,'href="mailto:$1@$2"');//add mailto: to any email addresses missing it
    job_desc_cleaned = job_desc_cleaned.replaceAll(/http:\/\/([^\s]+)@([^\s]+)"/sig, 'mailto:$1@$2"');// find links that should be mailto: and start with http
    
    return job_desc_cleaned
}

export const removeMainCat = (job_category) => {
    let cleaned_job_cat = job_category;


    try {
        if(!cleaned_job_cat.match(/(^|\s)(Homehealth|COVID-19|Physicians-.*?)(\s|$)/ig)) cleaned_job_cat = /-(.+)/.exec(job_category)[1];
    }
    catch {
        
    }

    return cleaned_job_cat.trim();
}

export const formatDate = (date_string) => {
    let date = new Date(date_string),
        year = date.getFullYear(),
        month = date.toLocaleString('default', {month: 'long'}),
        day = date.getDate(); 


   return `${month} ${day}, ${year}`
    
}

export const formatShortDate = (date_string) => {
    let date = new Date(date_string),
        year = date.getFullYear().toString().substr(-2),
        month =date.toLocaleString('default', {month: '2-digit'}),
        day = date.toLocaleString('default', {day: '2-digit'})


   return `${month}/${day}/${year}`
    
}

export const getFullState = (state_abbr) => {
    let states = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "DC": "District Of Columbia",
        "FL": "Florida",
        "GA": "Georgia",
        "GU": "Guam",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PW": "Palau",
        "PA": "Pennsylvania",
        "PR": "Puerto Rico",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VI": "Virgin Islands",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
    };

    return (states[state_abbr] !== undefined) ? states[state_abbr] : state_abbr;
}

export const getAbbrState = (full_state) => {
    let states = {
        "Alabama":"AL", 
        "Alaska":"AK", 
        "Arizona":"AZ", 
        "Arkansas":"AR", 
        "California":"CA", 
        "Colorado":"CO", 
        "Connecticut":"CT", 
        "Delaware":"DE", 
        "District Of Columbia":"DC", 
        "Florida":"FL", 
        "Georgia":"GA", 
        "Guam":"GU", 
        "Hawaii":"HI", 
        "Idaho":"ID", 
        "Illinois":"IL", 
        "Indiana":"IN", 
        "Iowa":"IA", 
        "Kansas":"KS", 
        "Kentucky":"KY", 
        "Louisiana":"LA", 
        "Maine":"ME", 
        "Marshall Islands":"MH", 
        "Maryland":"MD", 
        "Massachusetts":"MA", 
        "Michigan":"MI", 
        "Minnesota":"MN", 
        "Mississippi":"MS", 
        "Missouri":"MO", 
        "Montana":"MT", 
        "Nebraska":"NE", 
        "Nevada":"NV", 
        "New Hampshire":"NH", 
        "New Jersey":"NJ", 
        "New Mexico":"NM", 
        "New York":"NY", 
        "North Carolina":"NC", 
        "North Dakota":"ND", 
        "Ohio":"OH", 
        "Oklahoma":"OK", 
        "Oregon":"OR", 
        "Palau":"PW", 
        "Pennsylvania":"PA", 
        "Puerto Rico":"PR", 
        "Rhode Island":"RI", 
        "South Carolina":"SC", 
        "South Dakota":"SD", 
        "Tennessee":"TN", 
        "Texas":"TX", 
        "Utah":"UT", 
        "Vermont":"VT", 
        "Virgin Islands":"VI", 
        "Virginia":"VA", 
        "Washington":"WA", 
        "West Virginia":"WV", 
        "Wisconsin":"WI", 
        "Wyoming": "WY", 
    };

    return (states[full_state] !== undefined) ? states[full_state] : full_state;
}

export const sortFacet = (arr) => {
    arr.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
      
        // names must be equal
        return 0;
    });

    return arr;
}

export const FriendlyFacetURLs = (predefined_cats, state=null, city=null) => {
    let final_url = "javascript:void(0);";

    if(predefined_cats.length>0) {
        final_url = window.location.pathname;
        
        if (final_url.includes('/c-')) final_url = final_url.split('/c-')[0]+"/"; //remove anything after "/c-"
        if(final_url.includes('/s-')) final_url = final_url.split('/s-')[0]+"/"; //remove anything after "/s-"


        if (city !== null) {
            city = city.toLowerCase().trim().replaceAll(/[\s_]/ig, "-")
            final_url+= `c-${city}-`
        }

        if (state !== null) {
            state = state.toLowerCase().trim().replaceAll(/[\s_]/ig, "-")
            final_url+= `s-${state}/`
        }
    }

    return final_url

}

export const RemovePageQSFromURL = () => {
    const href = window.location.href;

    if(href.indexOf('?pg=')) {
        let url = href.replace(/\?pg=[^&]+/i, "")
        url = (url.indexOf('&')) && url.replace(/&/, "?") //basically, if there was more QS params we keep those and change the first "&"" to a "?""
        window.history.pushState(null, null, url);
    }
}

export const scrollToTopOfJobs = () => {
    let topOfJobs = (window.innerWidth >= 992) ? document.getElementById("TopOfJobs") : document.getElementById("SearchSubmit");
    
    if(typeof(topOfJobs) != 'undefined' && topOfJobs != null) {
        topOfJobs.scrollIntoView({
            behavior: 'smooth', // smooth scroll
            block: 'start' // the upper border of the element will be aligned at the top of the visible part of the window of the scrollable area.
        });
    }
}